import { createFileRoute } from '@tanstack/react-router';
import { NotificationGeneratedGridPage } from '../../features/notifications/NotificationGeneratedGridPage';

export const Route = createFileRoute('/_protected/notifications')({
  component: NotificationGeneratedGridPage,
});
